<template>
  <div class="full-page-modal">
    <div class="full-page-modal-header">
      <span>
        {{ headerText }}
      </span>
      <span>
        <slot name="timer"></slot>
      </span>
    </div>
    <div class="full-page-modal-container">
      <div
        class="full-page-modal-content"
      >
        <h1>{{ headerText }}</h1>
        <div
          class="content-text"
          v-html="contentText"
        >
        </div>
        <div
          v-if="isLoading"
          class="loading-container"
        >
          <loading-bar></loading-bar>
        </div>
        <div
          v-else
          class="button-container"
        >
          <button
            v-if="primaryButtonText"
            class="full-page-modal-button primary"
            data-test="primary-button"
            @click="$emit('primary-button-click')"
          >
            {{ primaryButtonText }}
          </button>
          <button
            v-if="secondaryButtonText"
            class="full-page-modal-button"
            data-test="secondary-button"
            @click="$emit('secondary-button-click')"
          >
            {{ secondaryButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingBar from '@/components/singletons/loading-bar';

export default {
  components: {
    LoadingBar,
  },
  props: {
    headerText: {
      type: String,
      default: 'Header Text',
    },
    contentText: {
      type: String,
      default: '<p>Lorem ipsum dolor sit amet, in ius errem aperiam, te adipisci referrentur mel. Liber vidisse has no, idque everti omittantur eos ex. Nec labore aliquando id, ex vel altera nostrud, postulant vulputate qui ad. Ne mei eius idque nusquam, ne pri quod oblique. Et audire aliquip volutpat vix.</p>',
    },
    primaryButtonText: {
      type: String,
      default: 'Primary',
    },
    secondaryButtonText: {
      type: String,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['primary-button-click', 'secondary-button-click'],
};
</script>

<style lang='scss' scoped>
$sim-background-color: #00629E;
$header-height: 4.5rem;
$border-width: 1rem;

.full-page-modal {
  margin: 0;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 1000;
  background-color: $sim-background-color;

  .full-page-modal-header {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    height: $header-height;
    color: white;
    padding: 0 2.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.25rem;
    font-weight: 600;
  }

  .full-page-modal-container {
    position: fixed;
    top: $header-height;
    left: $border-width;
    right: $border-width;
    bottom: $border-width;
    overflow: auto;
    padding: 0 1.5rem;
    background-color: white;
    border-top: 2rem solid #83AFDF;
    display: grid;
    justify-content: center;
    align-content: center;

    .full-page-modal-content {
      max-width: 828px;
    }
  }

  .button-container, .loading-container {
    margin-top: 2.5rem;
  }

  h1 {
    margin-block-end: 0.5rem;
    font-size: 1.5rem;
    font-weight: 600;
  }

  .content-text {
    font-size: 1.25rem;
    line-height: 2rem;
  }

  .full-page-modal-button {
    width: 248px;
    height: 72px;
    color: #00629E;
    font-size: 1.25rem;
    font-weight: 600;
    background-color: white;
    border: 2px solid #00629E;
    border-radius: 4px;
    margin-right: 1rem;

    &.primary {
      background-color: #00629E;
      color: white;
    }
  }
}
</style>
